import { useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useManageBonus } from '../../hooks/useManageBonus';
import { BonusAssignmentModel, getEmployeeFullName } from '../../models/bonusAssignmentModel';
import { AppContext } from '../../../../common';

export interface DeleteBonusModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: BonusAssignmentModel[];
    reHidrate: () => void;
    deleteBonusAssignments: (ids: number[]) => void;
    isDeleting: boolean;
    setSelectedList: (list: BonusAssignmentModel[]) => void; 
}

export const DeleteBonusModal = ({
    isOpen,
    onClose,
    data,
    reHidrate,
    deleteBonusAssignments,
    isDeleting,
    setSelectedList
}: DeleteBonusModalProps) => {
    const { langResources } = useContext(AppContext);
    const handleDelete = () => {
        const ids = data.map((item) => item.id);
        deleteBonusAssignments(ids);
        setSelectedList([]);
        onClose();
    };

    return (
        <Modal show={isOpen} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{langResources['bonus']['delete']['modal.title']}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {langResources['bonus']['delete']['confirmation.message']} {data.length} {langResources['bonus']['delete']['confirmation.suffix']}
                </p>
                <ul>
                    {data.slice(0, 5).map((item) => (
                        <li key={item.id}>
                            {getEmployeeFullName(item.employee)} - {item.bonusRule.name}
                        </li>
                    ))}
                    {data.length > 5 && <li>{langResources['bonus']['delete']['more.items']} {data.length - 5} más</li>}
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={onClose} disabled={isDeleting}>
                    {langResources['bonus']['delete']['cancel.button']}
                </Button>
                <Button variant='danger' onClick={handleDelete} disabled={isDeleting}>
                    {isDeleting ? langResources['bonus']['delete']['deleting.button'] : langResources['bonus']['delete']['delete.button']}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};